// Feature component for creating a new case

interface NewCaseProps {
  onSuccess?: () => void;
  onCancel?: () => void;
}

export function NewCase({ onSuccess }: NewCaseProps) {
  const handleNewCase = () => {
    // This would typically open a modal or form to create a new case
    // For now, we'll just trigger the NewCaseForm from the parent component
    if (onSuccess) {
      onSuccess();
    }
  };

  return (
    <button 
      onClick={handleNewCase}
      className="flex items-center gap-2 bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded-lg transition-colors"
    >
      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
      </svg>
      <span>New Case</span>
    </button>
  );
}
